module.exports = __webpack_public_path__ + "img/vi.a6eb130c.svg";